import { useContext } from "react";

import { DailyUserContext } from "../contexts/DailyUserContext";
// import { AuthContext } from "../contexts/FirebaseAuthContext";
// import { AuthContext } from "../contexts/Auth0Context";
// import { AuthContext } from "../contexts/CognitoContext";

const useDailyUser = () => {
  const context = useContext(DailyUserContext);

  if (!context) throw new Error("DailyUserContext must be placed within DailyUserProvider");

  return context;
};

export default useDailyUser;
